export function run() {
  const container = document.querySelector("[data-controller=Agreement]")

  if (!container) return

  const checkboxTarget = container.querySelector("[data-target=checkbox]")
  const submitTarget = container.querySelector("[data-target=submit]")

  function toggleAgreement() {
    submitTarget.disabled = !checkboxTarget.checked
  }

  checkboxTarget.addEventListener("click", toggleAgreement)
}
